import { render } from "./flow-type-selection.vue?vue&type=template&id=a0be28e8&lang=pug"
import script from "./flow-type-selection.vue?vue&type=script&lang=js"
export * from "./flow-type-selection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__